import Trajectory from '@/models/Trajectory';

const GET_TRAJECTORY = 'get_trajectory';
const GET_TRAJECTORY_REQUEST = 'get_trajectory_request';
const GET_TRAJECTORY_SUCCESS = 'get_trajectory_success';
const GET_TRAJECTORY_ERROR = 'get_trajectory_error';

export { GET_TRAJECTORY };

export default {
    state: {
        trajectory: {},
        loading: false,
        trajectoryErrors: [],
    },
    mutations: {
        [GET_TRAJECTORY_REQUEST]: (state) => {
            state.trajectory = {};
            state.loading = true;
            state.trajectoryErrors = [];
        },
        [GET_TRAJECTORY_SUCCESS]: (state, { trajectory }) => {
            state.trajectory = trajectory;
            state.loading = false;
            state.trajectoryErrors = [];
        },
        [GET_TRAJECTORY_ERROR]: (state, { errors }) => {
            state.trajectory = {};
            state.loading = false;
            state.trajectoryErrors = errors;
        },
    },
    actions: {
        [GET_TRAJECTORY]: ({ commit, state }, { id = state.trajectory.id }) => {
            commit(GET_TRAJECTORY_REQUEST);
            return new Promise((resolve, reject) => {
                Trajectory.document(id)
                    .then(trajectory => {
                        commit(GET_TRAJECTORY_SUCCESS, { trajectory });
                        resolve(trajectory);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_TRAJECTORY_ERROR, { errors });
                        reject(({ status, errors }));
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/trajectory.js